// extracted by mini-css-extract-plugin
module.exports = {"spinnerStyle":"Invoices_spinnerStyle__2TEGQ","table":"Invoices_table__1UXnn","tooltip":"Invoices_tooltip__3aksm"};